"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.disableSelectStyleReset = exports.disableSelectStyle = exports.thumbVerticalStyleDefault = exports.thumbHorizontalStyleDefault = exports.trackVerticalStyleDefault = exports.trackHorizontalStyleDefault = exports.viewStyleUniversalInitial = exports.viewStyleAutoHeight = exports.viewStyleDefault = exports.containerStyleAutoHeight = exports.containerStyleDefault = void 0;
exports.containerStyleDefault = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%',
};
exports.containerStyleAutoHeight = {
    height: 'auto',
};
exports.viewStyleDefault = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch',
};
exports.viewStyleAutoHeight = {
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined,
};
exports.viewStyleUniversalInitial = {
    overflow: 'hidden',
    marginRight: 0,
    marginBottom: 0,
};
exports.trackHorizontalStyleDefault = {
    position: 'absolute',
    height: 6,
};
exports.trackVerticalStyleDefault = {
    position: 'absolute',
    width: 6,
};
exports.thumbHorizontalStyleDefault = {
    position: 'relative',
    display: 'block',
    height: '100%',
};
exports.thumbVerticalStyleDefault = {
    position: 'relative',
    display: 'block',
    width: '100%',
};
exports.disableSelectStyle = {
    userSelect: 'none',
};
exports.disableSelectStyleReset = {
    userSelect: 'auto',
};
